<footer>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-top">
                    <div class="row">

                        <div class="col-lg-6">
                            <div class="about-enago">
                                <h3>트링카란?</h3>
                                <p>
                                    트링카는 인공지능 AI 기반으로 작동되는 영어 문법 수정 툴로 단순한 영어 문법 오류뿐만 아니라 학문이나 기술적인 작문을 위해 고안된 글쓰기 강화 보조 툴입니다. 트링카는 실시간으로 문장에 맞는 단어 및 문장을 제공함으로써
                                    문맥상의 철자 오류와 어드밴스 레벨로 문법 오류를 수정합니다. 이 모든 기능은 전문가와 학자들이 형식적이고 간결하지만 원고가 돋보일 수 있도록 글을 작성하는데
                                    많은 도움이 될 수 있습니다. 트링카의 엔터프라이즈 솔루션은 트링카의 모든 기능을 제한 없이 무제한 액세스 가능하며 사용자 개별에 맞게 옵션을 제공합니다.
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="install-in">
                                <h3>설치 가능한 플랫폼</h3>
                                <ul>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/wordplugin">
                                                <img src="../../../assets/images/NewWordAdd_in.svg" alt="word_add"> </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/wordplugin"> Microsoft Word용Windows</a>
                                        </span>
                                        <!-- <a routerLink="/wordplugin"></a> -->
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/browser-plugin/">
                                                <img src="../../../assets/images/NewChromeFicon.svg" alt="chrome">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/browser-plugin/">구글 크롬</a>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/browser-plugin/">
                                                <img src="../../../assets/images/NewFirefoxFicon.svg" alt="firefox">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/browser-plugin/">모질라 파이어 폭스</a>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <a routerLink="/browser-plugin/">
                                                <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge" width="42">
                                            </a>
                                        </span>
                                        <span class="install-in-browser">
                                            <a routerLink="/browser-plugin/">마이크로소프트 엣지</a>
                                        </span>

                                    </li>
                                    <li>
                                        <span class="browser-icon">
                                            <img src="../../../assets/images/UpcomingWord.svg" alt="word">
                                        </span>
                                        <span class="install-in-browser">Mac OS 용 MS Word </span>
                                    </li>
                                    <li>
                                        <span class="browser-icon upcoming-icon">
                                            <img src="../../../assets/images/UpcomingSafari_icon.png" alt="safari">
                                        </span>
                                        <span class="install-in-browser">사파리 브라우저</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="contact" id="footerEmailBox">
                                <form class="form-inline" (ngSubmit)="subscribeNow()" [formGroup]="footerFroms">
                                    <div class="form-group mx-sm-3 mb-2 ml-0" [ngClass]="(!footerFroms.get('footeremailform').valid && footerFroms.get('footeremailform').dirty) || (footerFroms.get('footeremailform').touched && footerFroms.get('footeremailform').pristine) ? 'TextFiledError' : '' ">

                                        <mat-form-field appearance="outline">
                                            <mat-label>이메일 입력</mat-label>
                                            <input matInput placeholder="" formControlName="footeremailform" class="form-control" name="email">
                                        </mat-form-field>
                                    </div>
                                    <button type="submit"  [disabled]="!footerFroms.valid" id="footerSubscribe" class="btn btn-primary mb-2">구독 신청 </button>
                                </form>
                            </div>

                        </div>


                    </div>
                    <div class="row">

                        <div class="col-lg-12">
                            <div class="row footer_menu_wrap">
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>회사</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/aboutus']" routerLinkActive="active">소개</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/contactus']" routerLinkActive="active">연락처</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/workwithus']" routerLinkActive="active">채용</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/affiliates']" routerLinkActive="active">제휴 프로그램</a>
                                            </li>
                                            <!-- <li>
                                                <a [routerLink]="['/accomplishments']" routerLinkActive="active">Accomplishments</a>
                                            </li> -->
                                        </ul>
                                    </div>
                                    <div class="footer_menu_one">
                                        <h3>더 알아보기</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a href="https://www.trinka.ai/blog/"  target="_blank">블로그</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/examples']" routerLinkActive="active">샘플</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/faqs']" routerLinkActive="active">FAQs</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>기능</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/features']" routerLinkActive="active">모든 기능</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/plagiarism-check']" routerLinkActive="active">표절 검사</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/kr/features/auto-file-edit" routerLinkActive="active">자동 파일 교정</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/latex-grammar-checker']" routerLinkActive="active">LaTeX 문법 검사기</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/paraphraser']" routerLinkActive="active">Online Paraphraser</a>
                                            </li>
                                            <li>
                                                <a href="https://www.trinka.ai/kr/features/publication-readiness-checks" routerLinkActive="active">출판 준비 체크</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/consistency-check']" routerLinkActive="active">일관성 체크</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/personal-dictionary']" routerLinkActive="active">개인용 사전</a>
                                            </li>
                                            <li>
                                                <a href="https://www.enago.com/plagiarism-checker/" target="_blank">표절 검사</a>
                                            </li>

                                            <li>
                                                <a [routerLink]="['/features/credits']" routerLinkActive="active">트링카 크레딧 안내</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>엔터프라이즈 솔루션</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']" routerLinkActive="active">생명과학, 의학 및 제약</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/language-services-publishing-and-media']" routerLinkActive="active">언어 서비스, 출판 및 미디어</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/academic-institutions']" routerLinkActive="active">학술 기관</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/k12-and-elearning']" routerLinkActive="active">K-12 및 E-러닝</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/technology-platforms']" routerLinkActive="active">기술 플랫폼</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">엔터프라이즈 통합 </a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise/grammar-checker-api']" routerLinkActive="active">문법 검사기 API</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/features/documark']" routerLinkActive="active">DocuMark</a>
                                            </li>
                                            <!-- <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">Trinka API</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/enterprise']" routerLinkActive="active">Trinka On-Premise</a>
                                            </li> -->


                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>툴 비교</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/trinka-vs-grammarly']" routerLinkActive="active">트링카 vs Grammarly</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-ginger']" routerLinkActive="active">트링카 vs. Ginger</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-languagetool']" routerLinkActive="active">트링카 vs. LanguageTool</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/trinka-vs-writefull']" routerLinkActive="active">트링카 vs. Writefull</a>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="footer_menu_one">
                                        <h3>기타</h3>
                                        <ul class="ftr-menu">
                                            <li>
                                                <a [routerLink]="['/grammar-checker']" routerLinkActive="active">문법 검사기/</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/paraphrasing-tool']" routerLinkActive="active">온라인 의역 도구</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/ai-content-detector']" routerLinkActive="active">AI 콘텐츠 탐지기</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/punctuation-checker']" routerLinkActive="active">구두점 검사기</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/spell-checker']" routerLinkActive="active">철자 검사기</a>
                                            </li>
                                            <li>
                                                <a [routerLink]="['/sentence-checker']" routerLinkActive="active">문장 ​​검사기</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="purple-bg">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <p>도움이 필요한 경우
                        <a href="mailto:support@trinka.ai">support@trinka.ai</a> 로 문의 바랍니다.
                    </p>
                </div>
            </div>
        </div>
    </div> -->
    <div class="footer-separator"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-middle">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="powerd-by">
                                <div class="powered-by-left">
                                    <h3>Powered by:</h3>
                                    <p>
                                        <a href="https://www.enago.co.kr/" target="_blank" class="footer_logos">
                                            <img src="../../../assets/images/enago-logo.png" alt="enago-english-editing-service" class="enago logo" />
                                        </a>
                                    </p>
                                </div>
                                <div class="powered-by-right">
                                    <p>이나고는 전 세계 125개국 이상 비영어권 연구진들의 공동체를 개선하고 성공적으로 연구논문이 출판될 수 있도록 함께 협력합니다. 전 세계 2만여 명이 이나고
                                        서비스를 만족하는 만큼 신뢰할 수 있는 글로벌 기업입니다.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="footer_menu_one footer_menu_last">
                                <h3>이나고 서비스</h3>
                                <ul class="ftr-menu">
                                    <li>
                                        <a href="https://www.enago.co.kr/editing-services.htm" target="_blank">영문교정</a>
                                    </li>
                                    <li>
                                        <a href="https://www.enago.co.kr/publication-support/" target="_blank">저널투고</a>
                                    </li>
                                    <li>
                                        <a href="https://www.enago.co.kr/translation/publish-ready-translation.htm" target="_blank">학술번역</a>
                                    </li>
                                    <li>
                                        <a href="https://www.voxtab.com/" target="_blank">한영 번역 서비스</a>
                                    </li>
                                    <li>
                                        <a href="https://lifesciences.enago.co.kr/" target="_blank">의료 정보전달의 요구 사항</a>
                                    </li>
                                    <li>
                                        <a href="https://www.read.enago.com/" target="_blank">Literature Review & Analysis Tool</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="footer-bottom">
                    <div class="row">
                        <div class="col-md-7">
                            <p>© Crimson AI, {{ latestYear }}. Made in India.</p>
                            <ul class="ftr-menu1">
                                <li>
                                    <a href="mailto:support@trinka.ai">support@trinka.ai</a>
                                </li>
                                <li>
                                    <a id="PrivacyButton" [routerLink]="['/privacypolicy']" routerLinkActive="active">개인정보 정책</a>
                                </li>
                                <li>
                                    <a id="termsofserviceButton" [routerLink]="['/termsofservices']" routerLinkActive="active">서비스 약관</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-5">
                            <div class="follow-us">
                                <h3>구독하기</h3>
                                <ul class="social-media">
                                    <li>
                                        <a href="https://www.facebook.com/thetrinkaai/" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/thetrinkaai/" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/thetrinkaai" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/company/thetrinkaai" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-linkedin"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/channel/UC1PNKZCxdUArpPVr5YFaYcA" rel=" no referer, no opener" target="_blank">
                                            <i class="fa fa-youtube-play"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>


                            <div class="language_sections" id="languageDropDown">
                                <i class="fa fa-globe" aria-hidden="true"></i>
                                <span>한국어</span>
                                <ul class="drop">
                                    <li>
                                        <a href="https://www.trinka.ai/">
                                            English
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/jp/">
                                            日本語
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://trinka.enago.cn/">
                                            简体中文
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/tw/">
                                            繁体中文
                                        </a>
                                    </li>
                                    <li class="selected">
                                        <a>
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                            한국어
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/es/">
                                            Español
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.trinka.ai/pt/">
                                            Português
                                        </a>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
<div id="emailSubscribePopup" class="modal fade show" *ngIf="subscribePopup">
	<div class="modal-dialog modal-confirm">
		<div class="modal-content">
			<div class="modal-header flex-column">
				<div class="icon-box">
					<i class="material-icons">&#xE5CA;</i>
				</div>						
				<h4 class="modal-title w-100">Thank you for subscribing to our newsletter</h4>	
                <button type="button" (click)="dismissSubcribePopup()" id="emailSubcribeButton" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
			</div>
			<div class="modal-body">
                <p>Your subscription has been confirmed.</p>
			</div>
			<div class="modal-footer justify-content-center">
				<button type="button" (click)="dismissSubcribePopup()" id="emailSubcribeButton" class="btn btn-secondary" data-dismiss="modal">OK</button>
				<!-- <button type="button" class="btn btn-danger">Delete</button> -->
                <p>Note: If at any point of time you wish to opt out from the newsletters, you can simply click on "Unsubscribe" link at the bottom of newsletter.</p>
			</div>
		</div>
	</div>
</div>